function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Complete"
}, React.createElement("g", {
  id: "Circle"
}, React.createElement("circle", {
  cx: 12,
  cy: 12,
  "data-name": "Circle",
  fill: "none",
  id: "Circle-2",
  r: 10,
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgCircle = function SvgCircle(props) {
  return React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/circle.f3df94bd.svg";
export { SvgCircle as ReactComponent };